import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ApplicationConfiguration from './application-configuration';
import ApplicationConfigurationDetail from './application-configuration-detail';
import ApplicationConfigurationUpdate from './application-configuration-update';
import ApplicationConfigurationDeleteDialog from './application-configuration-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ApplicationConfigurationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ApplicationConfigurationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ApplicationConfigurationDetail} />
      <ErrorBoundaryRoute path={match.url} component={ApplicationConfiguration} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ApplicationConfigurationDeleteDialog} />
  </>
);

export default Routes;
